/**
 * @module components/layout/AppShell
 * @description Page-level shell: aurora background blobs, vignette overlay,
 * performance monitoring, and the toast host. Wraps the routed page content.
 *
 * @extracted-from client/src/App.js (lines ~961-971)
 */

import React from 'react';
import { Toaster } from 'react-hot-toast';
import PerformanceMonitor from '../PerformanceMonitor';
import { toastOptions } from '../../theme/toastTheme';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children - Page content rendered inside the shell.
 */
const AppShell = ({ children }) => {
  return (
    <div className="critic-shell min-h-screen relative">
      <div className="critic-aurora print:hidden" aria-hidden="true">
        <div className="critic-aurora__blob critic-aurora__blob--a" />
        <div className="critic-aurora__blob critic-aurora__blob--b" />
        <div className="critic-aurora__blob critic-aurora__blob--c" />
        <div className="critic-aurora__mesh" />
      </div>
      <div className="critic-vignette print:hidden" aria-hidden="true" />
      <PerformanceMonitor />
      <Toaster position="top-right" toastOptions={toastOptions} />

      {children}
    </div>
  );
};

export default AppShell;
